import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faArrowAltCircleUp } from "@fortawesome/free-solid-svg-icons"

export const ArrowAltCircleUp = (props) => {
  return <FontAwesomeIcon faIcon={faArrowAltCircleUp} {...props} />
}
